module.exports = __webpack_public_path__ + "img/arrow-down-right-square-fill.d24c444c.svg";